import { useEffect, useState } from 'react'
import { BaseFeedbackConIcona } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import useStateConSessione from 'utils/useStateConSessione'
import { useRichiestaServerLogged } from './useRichiestaServerLogged'

export default function useInfoComando() {
  const [infoComando, setInfoComando] = useStateConSessione(null, 'infoComando')
  const [messaggioErrore, setMessaggioErrore] = useState(null)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  useEffect(() => {
    async function getInfoComando() {
      if (infoComando) return
      const { ok, data } = await inviaOperazione(OPERAZIONI.INFO_COMANDO)
      if (ok) {
        const { esito, info, messaggio } = data
        if (esito) setInfoComando(info)
        else setMessaggioErrore(messaggio)
      }
    }
    getInfoComando()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [infoComando])

  const ScatolaMessaggiInfoComando = (
    <>
      {messaggioErrore && <BaseFeedbackConIcona.Errore messaggio={messaggioErrore} />}
      {ScatolaMessaggi}
    </>
  )

  return {
    infoComando,
    ScatolaMessaggiInfoComando,
    inAttesaInfoComando: inAttesaDelServer
  }
}